import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector';
import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';
import HeaderAppCommunities from '../../sections/header/HeaderAppCommunities';
// import AppCommunitiesSearchResultGrid from '../../sections/app_communitiesSearchResultGrid/AppCommunitiesSearchResultGrid';
import AppCommunitiesResultRows from '../../sections/app_communitiesResultRows/AppCommunitiesResultRows';
import AppPostButton from '../../components/app_postButton/AppPostButton';
import AppPost from '../../components/app_post/AppPost';

function AppCommunities() {
	const resultProfiles = useAppSelector((state) => state.search.resultProfiles)
	const showNewPost = useAppSelector((state) => state.user.showNewPost)
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			makeInitialSearchRequest()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(updateExploreProfiles())
			if (!successRequest) {
				console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
			}
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap'>
						<div className='section-content'>
							<HeaderAppCommunities />
						</div>
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space'>
						{/* {resultProfiles.length > 0 ?
							<AppCommunitiesSearchResultGrid
								title='Search'
								profiles={resultProfiles}
							/> :
							<AppCommunitiesResultRows />
						} */}
						<AppCommunitiesResultRows />
					</div>
					<BackToTopButton />
				</>
			}
			<AppPostButton />
			<AppFooter activeIndex={1} />
			{showNewPost && <AppPost />}
		</>
	)
}

export default AppCommunities
